var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVirtualBg = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56564 4.00033L20.4455 4C20.9784 4 21.4118 4.2023 21.7258 4.63567C21.8957 4.86892 21.9906 5.1481 21.998 5.43629C22 5.48852 22 5.54075 22 5.59298V18.4487C22 18.7839 21.9211 19.0929 21.7245 19.365C21.4124 19.7947 20.982 20 20.4522 20H19.4265C18.4828 17.9465 15.808 15.8696 11.9897 15.8696C8.17886 15.8696 5.50561 17.9465 4.56217 20H3.55635C3.02581 20 2.59475 19.8017 2.28074 19.3719C2.09785 19.1237 1.99975 18.8234 2.00088 18.5154C1.99956 18.3594 2 18.2032 2.00044 18.0471C2.00066 17.969 2.00088 17.891 2.00088 17.813V5.54372C2.00088 4.95797 2.25189 4.51105 2.74894 4.20329C2.99763 4.04958 3.27649 4.00033 3.56564 4.00033ZM15.71 10.1084C15.71 12.4277 13.9844 14.209 11.999 14.209C10.0044 14.209 8.28809 12.4277 8.28809 10.127C8.28809 7.854 10.0137 6.11914 11.999 6.11914C13.9844 6.11914 15.71 7.81689 15.71 10.1084Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVirtualBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-virtual-bg.551d34c3e62591c78d3c3cbf8197349b.svg";